<div class="centered">
  <mat-card class="speech-bubble">
  <table style="width: 100%; padding: 0px; margin: 0px; text-align: center">
    <tr>
      <td class="upperTd">
        <div class="maherlogo"></div>
        <div class="email"></div>
        <div class="titleFont" style="padding-bottom: 10px; padding-top: 10px; text-align: center">Enter Your Username </div>
        <div class="smallerFont" style="padding-bottom: 40px;">We Will Send A Code To The Email Listed In Your Account </div>
        <form  [formGroup]="myForm" autocomplete="off"   novalidate>
          <table  class="table-fill">
            <td>

              <mat-form-field appearance="outline" style="min-width: 88%" >
                <mat-label>Username</mat-label>
                <input maxlength="30" #username1 [(ngModel)]="myUser.username" oninput="this.value = this.value.toUpperCase()" matInput formControlName="username" [disabled]="submitted"/>
              </mat-form-field>
              <span *ngIf="f.username.errors" class="invalid-feedback">
                 <div class="errorDiv2"  *ngIf="f.username.errors.required && submitted">Username Required</div>
              </span>
              <div class="errorDiv2"  >If that's a valid account then you'll receive an email within a few minutes.</div>

            </td>
          </table>
        </form>
        <div style="padding-top: 5%;  padding-bottom: 10%">
          <button mat-raised-button class="redButton"  (click)="returnBack()" style="min-width: 42%" >Cancel</button>
          <span style="padding-right: 1%"></span>
          <button mat-raised-button class="blueButton"  (click)="sendEmail()" color="primary" style="min-width: 42%;">Send Code To Email</button>
        </div>
      </td>
      <td class="lowerTd daPic"></td>
    </tr>
  </table>
</mat-card>
</div>

